import { ThirdPartyTracksResponse } from 'anchor-server-common/utilities/spotifyApi';
import { normalizeSearchResponse } from 'anchor-server-common/utilities/spotifyHelper/dataNormalization';
import { isRawResponse } from '../../../../../helpers/music';

export async function fetchTracksBySpotifyPlaylistId({
  playlistId,
}: {
  playlistId: string;
}): Promise<ThirdPartyTracksResponse> {
  const response = await fetch(
    `/api/proxy/v3/music/spotify/playlist/tracks?playlistId=${playlistId}`,
    {
      method: 'GET',
      credentials: 'same-origin',
    }
  );

  if (!response.ok) {
    throw new Error(`Could not fetch playlist's tracks`);
  }

  const responsePlaylistTracks = await response.json();

  if (isRawResponse(responsePlaylistTracks)) {
    return normalizeSearchResponse(responsePlaylistTracks);
  }

  return responsePlaylistTracks;
}
